module.exports = __webpack_public_path__ + "static/img/deposit_bg.739083ba.png";